

















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptCommodityAnalyse extends Vue {

  // 商品分析表用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  // public closingDate: Date = null;
  public startDate: Date = null;
  public endDate: Date = null;    
  public segment: Common.Segment = null;
  public currencyCode : string = null;
  public hasLicenseCurrency: boolean = false;
  public onExcelExport :boolean = false;
  public startDateFlag : Common.dateFlags = Common.dateFlags.default;
  public endDateFlag : Common.dateFlags = Common.dateFlags.default;  

  public mounted(){
   if ((this.$parent as any).favoriteLoaded == false){     
    var query: Common.PurchaseCashBalanceTemplateQuery = new Common.PurchaseCashBalanceTemplateQuery();
    this.$api.execute(query).then(obj => {
      var items: Common.ReportTemplate[] = new Array();
      items = (obj as Common.LoadResult).result;
      if (items.length > 0) this.reportTemplate = items[0];
    });
   }
    var today = new Date().getCalendarDate();
    // this.closingDate = today;
    this.startDate = new Date(today.getFullYear(),today.getMonth(),1).getCalendarDate();
    this.endDate = new Date(today.getFullYear(),today.getMonth() +1,0).getCalendarDate();    
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    (this.$refs.dialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.PurchaseCashBalanceQuery = new Common.PurchaseCashBalanceQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    // query.closingDate = this.closingDate;
    query.startDate = this.startDate;
    query.endDate = this.endDate;    
    query.segment = this.segment;
    query.currencyCode = this.currencyCode;
    query.onExcelExport = this.onExcelExport;
    this.$api.download(query);
  }
}
